import React from "react";
import Link from "components/link";
import Image from "components/image";
import { useCart, useSettings } from "hooks/useStore";
import clsx from "clsx/lite";
import CartSummary from "./summary";
import CheckoutButton from "./checkout-button";

const CartFooter = ({ image, showEmptyCartSummary }) => {
	const { totalQuantity } = useCart(["totalQuantity"]);
	const { toggleCart } = useSettings(["toggleCart"]);
	const hasItemsInCart = totalQuantity > 0;

	return (
		<div className={clsx("cart-footer border-t-lightBeige", !showEmptyCartSummary && "shadow-top")}>
			<CartSummary showEmptyCartSummary={showEmptyCartSummary} />

			{hasItemsInCart || showEmptyCartSummary ? (
				<div className="flex flex-col gap-2 bg-white relative z-10">
					<CheckoutButton showEmptyCartSummary={showEmptyCartSummary} />
					<Link to="/cart" onClick={toggleCart} className="btn btn-quaternary w-full text-center review-cart-btn" >
						Review Cart
					</Link>

					{image && <div className="flex-center gap-4">
						<Image image={image} className="max-h-14 md:max-h-16 w-full h-full *:!object-contain" />
					</div>}
				</div>
			) : (
				<Link to="/collections/all-modern-light-fixtures" onClick={toggleCart}
					className="block w-fit text-lg mx-auto border-b border-black pb-0.5 tracking-widest my-6 uppercase">
					Continue shopping
				</Link>
			)}
		</div>
	);
};

export default CartFooter;